import {ApplicationState, collectionFactory, Reducer} from '@modifi/redux'
import createCachedSelector from 're-reselect'
import {getAuthenticatedShipmentsClient, ShipmentView} from '../../lib'
import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedShipmentsClient()

const {reducer, actions, selectors} = collectionFactory({
  rootSelector: state => state?.data?.shipments?.collection,
  actionNamePrefix: 'data/shipments/collection',
  entityPrimaryKeySelector: entity => entity.externalId,
  // @ts-expect-error wrong typing
  fetchRequest: (state, params) => {
    const {pageIndex, pageSize, orderBy, orderDirection} = params

    return apiClient.Shipments.fetch({pageIndex, pageSize, orderBy, orderDirection})
      .then(res => res.data())
      .then(data => ({
        // eslint-disable-next-line no-underscore-dangle
        meta: data?._meta ?? undefined,
        entities: data?.shipments ?? [],
      }))
  },
})

export default reducer as Reducer

export const selectShipments = createCachedSelector(
  (state: ApplicationState) => selectors.selectByKeyWindow(state),
  (
    state: ApplicationState,
    params: {
      pageIndex: number
      pageSize: number
      orderBy?: string[]
      orderDirection?: ('ASC' | 'DESC')[]
    }
  ) => params,
  (getByKeyWindow, params) => {
    const {pageIndex = 0, pageSize = 20, orderBy = [], orderDirection = []} = params
    return getByKeyWindow({pageIndex, pageSize, orderBy, orderDirection}) as ShipmentView[]
  }
)(
  (state, params) =>
    `${params.pageIndex || 0}|${params.pageSize || 20} |${params.orderBy || ''} |${
      params.orderDirection || ''
    }`
)

export const selectShipmentsMeta = createCachedSelector(
  (state: ApplicationState) => selectors.selectMetaByKeyWindow(state),
  (
    state: ApplicationState,
    params: {
      pageIndex: number
      pageSize: number
      orderBy?: string[]
      orderDirection?: ('ASC' | 'DESC')[]
    }
  ) => params,
  (getMetaByKeyWindow, params) => {
    const {pageIndex = 0, pageSize = 20, orderBy = [], orderDirection = []} = params
    return getMetaByKeyWindow({pageIndex, pageSize, orderBy, orderDirection}) as Record<string, any>
  }
)(
  (state, params) =>
    `${params.pageIndex || 0}|${params.pageSize || 20} |${params.orderBy || ''} |${
      params.orderDirection || ''
    }`
)

export const selectShipmentsWhereLoaded = createCachedSelector(
  (state: ApplicationState) => selectors.selectFetchCountByKeyWindow(state),
  (
    state: ApplicationState,
    params: {
      pageIndex: number
      pageSize: number
      orderBy?: string[]
      orderDirection?: ('ASC' | 'DESC')[]
    }
  ) => params,
  (getFetchCount, params) => {
    const {pageIndex = 0, pageSize = 20, orderBy = [], orderDirection = []} = params
    return (getFetchCount({pageIndex, pageSize, orderBy, orderDirection}) > 0) as boolean
  }
)(
  (state, params) =>
    `${params.pageIndex || 0}|${params.pageSize || 20} |${params.orderBy || ''} |${
      params.orderDirection || ''
    }`
)

export const aFetchShipments = (params: {
  pageIndex: number
  pageSize: number
  orderBy?: string[]
  orderDirection?: ('ASC' | 'DESC')[]
}): any => actions!.fetch(params)

export const aReFetchAllShipmentsKeyWindows = (): AppThunkAction<void> => (dispatch, getState) => {
  const keyWindows = selectors.selectAllKeyWindows(getState())

  return Promise.all(keyWindows.map(keyWindow => dispatch(actions!.fetch(keyWindow.id))))
}
